import script from "./RevisitConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisitConfirm.vue?vue&type=script&setup=true&lang=js"

import "./RevisitConfirm.vue?vue&type=style&index=0&id=3ba8abfc&lang=scss"
import "./RevisitConfirm.vue?vue&type=style&index=1&id=3ba8abfc&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ba8abfc"]])

export default __exports__